import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  ref: "modalRef",
  class: "modal-content neon"
}
const _hoisted_2 = { class: "wrapper" }
const _hoisted_3 = { class: "canvas-item" }
const _hoisted_4 = { class: "rating" }
const _hoisted_5 = { class: "palette-wrap" }
const _hoisted_6 = { class: "buttons" }
const _hoisted_7 = {
  key: 0,
  class: "see-more"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_modal_header = _resolveComponent("app-modal-header")!
  const _component_app_editor_canvas = _resolveComponent("app-editor-canvas")!
  const _component_app_palette = _resolveComponent("app-palette")!
  const _component_app_button = _resolveComponent("app-button")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_app_modal_header, {
      title: _ctx.t('top3'),
      onClose: _ctx.close
    }, null, 8, ["title", "onClose"]),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.results.slice(0, _ctx.end), (item, index) => {
        return (_openBlock(), _createElementBlock("section", {
          key: item,
          class: "wrapper-item"
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(index + 1) + ". " + _toDisplayString(_ctx.t(item.name)), 1),
            _createVNode(_component_app_editor_canvas, {
              ref_for: true,
              ref: (el) => (_ctx.editorCanvasRefs[index] = el),
              "image-url": _ctx.uniqueImageUrls(index),
              segments: item.segments
            }, null, 8, ["image-url", "segments"])
          ]),
          _createElementVNode("section", _hoisted_5, [
            _createVNode(_component_app_palette, {
              item: item,
              "palette-cards": _ctx.paletteCards
            }, null, 8, ["item", "palette-cards"]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_app_button, {
                severity: "success",
                title: "download",
                onClick: ($event: any) => (_ctx.saveToDevice(_ctx.editorCanvasRefs[index]))
              }, null, 8, ["onClick"]),
              _createVNode(_component_app_button, {
                severity: "info",
                title: "addSign",
                onClick: ($event: any) => (_ctx.openImageModal(_ctx.editorCanvasRefs[index], item.name))
              }, null, 8, ["onClick"]),
              _createVNode(_component_app_button, {
                severity: "warning",
                title: "saveToGallery",
                loading: _ctx.isSaveToGallery,
                onClick: ($event: any) => (_ctx.saveToGallery(_ctx.editorCanvasRefs[index], item.name))
              }, null, 8, ["loading", "onClick"])
            ])
          ])
        ]))
      }), 128)),
      (_ctx.end === 3)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_component_app_button, {
              severity: "gradient",
              gradient: "",
              title: "seeMore",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.end = 12))
            })
          ]))
        : _createCommentVNode("", true),
      (_ctx.end === 12)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "text-center",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
          }, [
            _createVNode(_component_router_link, {
              class: "txt2",
              to: { name: 'main-consultation' }
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('remainingInquiries')), 1)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ])
  ], 512))
}